export namespace HrajSRozumemAnalytics {
    export const pushContactFormSubmit = () => {
        window.dataLayer.push({
            event: "action.submit.contactForm",
        });
    };
}
